import PropTypes from 'prop-types';

import {Grid, GridItem} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component} from '@amblique/king-living/app/components/contentful/component';

/**
 * Range/Category Tile Grid Block (CF-030)
 *
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {"root"} SectionPanelParts
 * @typedef {Partial<Record<SectionPanelParts, SystemStyleObject>>} SectionPanelStyles
 *
 * @param {Object} props - Component props
 * @param {Contentful.SectionPanel} props.component - SectionPanel component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @param {SectionPanelStyles} [props.styles] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const RangeCategoryTileGridBlockCF030 = ({component, isComplete = true, isFetching = false, styles, ...props}) => {
  const {contentCollection} = component || {};

  if (!contentCollection?.items) {
    return null;
  }

  const validItems = contentCollection.items.filter(
    (item) => item != null && typeof item === 'object' && item.__typename && item.sys?.id
  );

  if (validItems.length === 0) {
    return null;
  }

  return (
    <Grid {...styles.container} {...props}>
      {validItems.map((item, index) => (
        <GridItem key={item.sys.id}>
          <Component key={item.sys.id} component={item} isComplete={isComplete} isFetching={isFetching} styles={styles} />
        </GridItem>
      ))}
    </Grid>
  );
};

RangeCategoryTileGridBlockCF030.displayName = 'RangeCategoryTileGridBlockCF030';
RangeCategoryTileGridBlockCF030.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};
